@@ -1,80 +0,0 @@
<template>
  <div class="card-live" role="button" @click="toLive(item)">
    <div class="thumbnail">
      <ImageResponsive
        v-if="item.thumbnail"
        :imageUrl="item.thumbnail"
        :fromUrl="true"
        class="card-live-thumbnail-image"
      />
      <div class="label-live">
        <p class="duration">LIVE</p>
      </div>
    </div>
    <div class="caption">
      <span>{{ item.channel.label }}</span>
      <h2>{{ item.liveName }}</h2>
      <span>{{ secondsToHms(item.startLive) }}</span>
    </div>
  </div>
</template>

<script>
import ImageResponsive from "@/components/ImageResponsive";

export default {
  components: {
    ImageResponsive,
  },
  methods: {
    toLive(item) {
      window.$nuxt.$store.commit("config/setLoading", true);
      window.location.href = this.$router.resolve(`/live/${item.slug}`).href;
    },
    secondsToHms(param) {
      let now = this.$moment(new Date()).format("DD/MM/YYYY HH:mm:ss");
      let then = this.$moment(param).format("DD/MM/YYYY HH:mm:ss");
      let ms = this.$moment(now, "DD/MM/YYYY HH:mm:ss").diff(
        this.$moment(then, "DD/MM/YYYY HH:mm:ss")
      );
      let d = this.$moment.duration(ms);
      let s = d._data;
      let streaming_time = "";
      let hours = s.hours;
      let minutes = s.minutes;
      let seconds = s.seconds;

      if (seconds != 0) {
        streaming_time = "Streaming dimulai " + seconds + " detik yang lalu";
      }
      if (minutes != 0) {
        streaming_time =
          "Streaming dimulai " +
          minutes +
          " menit " +
          seconds +
          " detik yang lalu";
      }
      if (hours != 0) {
        streaming_time =
          "Streaming dimulai " + hours + " jam " + minutes + " menit yang lalu";
      }
      return streaming_time;
    },
  },
  props: {
    item: {
      type: Object,
      default: null,
    },
  },
};
</script>

<style lang="scss" scoped>
.card-live {
  display: flex;
  height: 177px;
  background-color: #f1f1f1;

  .thumbnail {
    position: relative;
    margin-right: 10px;

    .card-live-thumbnail-image {
      width: 317px;
      border-radius: 10px;
    }

    .label-live {
      background: #e73638;
      padding: 3px 6px;
      position: absolute;
      bottom: 0;
      height: 20px;
      display: flex;
      right: 0;
      border-top-left-radius: 10px;
      border-bottom-right-radius: 10px;
      justify-content: center;
      align-items: center;
      &:before {
        margin-right: 5px;
        content: url("data:image/svg+xml,%3Csvg width='17' height='12' viewBox='0 0 17 12' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M3.55035 1.05076C2.90025 1.70078 2.38456 2.47248 2.03273 3.32181C1.68089 4.17113 1.49981 5.08144 1.49981 6.00075C1.49981 6.92006 1.68089 7.83037 2.03273 8.6797C2.38456 9.52902 2.90025 10.3007 3.55035 10.9507C3.64143 11.045 3.69183 11.1713 3.69069 11.3024C3.68955 11.4335 3.63696 11.559 3.54426 11.6517C3.45155 11.7444 3.32614 11.7969 3.19504 11.7981C3.06394 11.7992 2.93764 11.7488 2.84334 11.6577C2.10041 10.9149 1.51109 10.0329 1.10901 9.06231C0.706944 8.09168 0.5 7.05136 0.5 6.00075C0.5 4.95014 0.706944 3.90982 1.10901 2.93919C1.51109 1.96856 2.10041 1.08663 2.84334 0.343757C2.93764 0.252678 3.06394 0.202281 3.19504 0.20342C3.32614 0.20456 3.45155 0.257144 3.54426 0.349848C3.63696 0.442552 3.68955 0.567958 3.69069 0.699056C3.69183 0.830155 3.64143 0.956456 3.55035 1.05076ZM5.67239 3.17275C4.92249 3.92286 4.50122 4.9401 4.50122 6.00075C4.50122 7.06141 4.92249 8.07864 5.67239 8.82875C5.71888 8.87524 5.75575 8.93043 5.78091 8.99117C5.80607 9.05191 5.81902 9.11701 5.81902 9.18275C5.81902 9.24849 5.80607 9.31359 5.78091 9.37433C5.75575 9.43507 5.71888 9.49026 5.67239 9.53675C5.6259 9.58324 5.57071 9.62011 5.50997 9.64527C5.44923 9.67043 5.38413 9.68338 5.31838 9.68338C5.25264 9.68338 5.18753 9.67043 5.12679 9.64527C5.06605 9.62011 5.01086 9.58324 4.96437 9.53675C4.49993 9.07244 4.13151 8.52119 3.88015 7.91447C3.62879 7.30776 3.49942 6.65747 3.49942 6.00075C3.49942 5.34403 3.62879 4.69375 3.88015 4.08703C4.13151 3.48032 4.49993 2.92907 4.96437 2.46476C5.05826 2.37087 5.1856 2.31812 5.31838 2.31812C5.45116 2.31812 5.5785 2.37087 5.67239 2.46476C5.76628 2.55864 5.81902 2.68598 5.81902 2.81875C5.81902 2.95153 5.76628 3.07887 5.67239 3.17275ZM11.3285 2.46476C11.3749 2.41819 11.4301 2.38125 11.4909 2.35604C11.5516 2.33084 11.6167 2.31786 11.6825 2.31786C11.7483 2.31786 11.8134 2.33084 11.8741 2.35604C11.9349 2.38125 11.9901 2.41819 12.0365 2.46476C12.5009 2.92907 12.8694 3.48032 13.1207 4.08703C13.3721 4.69375 13.5015 5.34403 13.5015 6.00075C13.5015 6.65747 13.3721 7.30776 13.1207 7.91447C12.8694 8.52119 12.5009 9.07244 12.0365 9.53675C11.99 9.58324 11.9348 9.62011 11.8741 9.64527C11.8133 9.67043 11.7482 9.68338 11.6825 9.68338C11.6168 9.68338 11.5517 9.67043 11.4909 9.64527C11.4302 9.62011 11.375 9.58324 11.3285 9.53675C11.282 9.49026 11.2451 9.43507 11.22 9.37433C11.1948 9.31359 11.1819 9.24849 11.1819 9.18275C11.1819 9.11701 11.1948 9.05191 11.22 8.99117C11.2451 8.93043 11.282 8.87524 11.3285 8.82875C12.0784 8.07864 12.4997 7.06141 12.4997 6.00075C12.4997 4.9401 12.0784 3.92286 11.3285 3.17275C11.2819 3.12631 11.245 3.07113 11.2198 3.01039C11.1946 2.94964 11.1816 2.88452 11.1816 2.81875C11.1816 2.75299 11.1946 2.68787 11.2198 2.62712C11.245 2.56638 11.2819 2.5112 11.3285 2.46476ZM13.4505 0.344757C13.5443 0.251022 13.6715 0.198364 13.804 0.198364C13.9366 0.198364 14.0638 0.251022 14.1575 0.344757C15.6576 1.84502 16.5004 3.8797 16.5004 6.00125C16.5004 8.12281 15.6576 10.1575 14.1575 11.6577C14.0632 11.7488 13.9369 11.7992 13.8058 11.7981C13.6747 11.7969 13.5493 11.7444 13.4566 11.6517C13.3639 11.559 13.3113 11.4335 13.3102 11.3024C13.3091 11.1713 13.3595 11.045 13.4505 10.9507C14.1006 10.3007 14.6163 9.52902 14.9682 8.6797C15.32 7.83037 15.5011 6.92006 15.5011 6.00075C15.5011 5.08144 15.32 4.17113 14.9682 3.32181C14.6163 2.47248 14.1006 1.70078 13.4505 1.05076C13.3568 0.956993 13.3041 0.829839 13.3041 0.697257C13.3041 0.564675 13.3568 0.437521 13.4505 0.343757V0.344757ZM10.5005 6.00075C10.5005 6.53118 10.2898 7.03989 9.91468 7.41496C9.5396 7.79004 9.03088 8.00075 8.50044 8.00075C7.97 8.00075 7.46128 7.79004 7.0862 7.41496C6.71112 7.03989 6.5004 6.53118 6.5004 6.00075C6.5004 5.47032 6.71112 4.96161 7.0862 4.58654C7.46128 4.21147 7.97 4.00075 8.50044 4.00075C9.03088 4.00075 9.5396 4.21147 9.91468 4.58654C10.2898 4.96161 10.5005 5.47032 10.5005 6.00075Z' fill='white'/%3E%3C/svg%3E%0A");
      }
      @media only screen and (max-width: 1024px) {
        border-top-left-radius: 6px;
      }

      &.backgroundAds {
        background: rgba(128, 128, 128, 0.7);
        padding: 3px 8px;
      }
      .advertorial {
        font-size: 12px;
        font-weight: 500;
        color: #ffffff;
        margin: 0;
        @media only screen and (max-width: 1024px) {
          font-size: 10px;
        }
      }
      .duration {
        font-size: 12px;
        font-weight: 500;
        color: #ffffff;
        margin: 0;
        @media only screen and (max-width: 1024px) {
          font-size: 10px;
        }
      }
    }
  }

  .caption {
    span:first-child {
      overflow: hidden;
      text-overflow: ellipsis;
      -webkit-line-clamp: 1;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      color: #4a25aa;
      font-size: 12px;
    }

    h2 {
      overflow: hidden;
      text-overflow: ellipsis;
      -webkit-line-clamp: 3;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      font-weight: 500;
      color: #0c0b0d;
      font-size: 16px;
    }

    span {
      color: #757575;
      font-size: 12px;
      overflow: hidden;
      text-overflow: ellipsis;
      -webkit-line-clamp: 2;
      display: -webkit-box;
      -webkit-box-orient: vertical;
    }
  }
}
</style>
